import React from 'react';
import axios from 'axios';

import './LanguagesPage.css';

import ru from './../../images/ru.png';
import en from './../../images/en.png';

const LanguagesPage = ({
    setCurrentPage,
    setChannelLink,
    loadingCategories,
}) => {
    // обработка выбора языка
    const handleLanguageClick = (language) => {
        localStorage.setItem('userLanguage', language);
        const selectedLanguage = localStorage.getItem('userLanguage');
        const initData = window.Telegram.WebApp.initData;

        axios
            .post(
                'https://mepointserver.ru/api/auth',
                {
                    initData: initData,
                    avatarLink: '',
                    language: selectedLanguage,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            .then((response) => {
                const token = response.data.result.token;
                localStorage.setItem('authToken', token);

                const isSubscribeChannel =
                    response.data.result.isSubscribeChannel;

                console.log('Авторизация:', response.data.result);

                if (isSubscribeChannel) {
                    loadingCategories();
                    setCurrentPage('MapPage');
                } else {
                    if (language === 'ru-RU') {
                        setChannelLink('https://t.me/MePoint_RU');
                    } else {
                        setChannelLink('https://t.me/MePoint_EN');
                    }
                    setCurrentPage('SubscribePage');
                }
            })
            .catch((error) => {
                console.error('Ошибка авторизации', error);
            });
    };

    return (
        <div className='languages__page'>
            <div className='languages__button'>
                <button onClick={() => handleLanguageClick('ru-RU')}>
                    <img src={ru} alt='ru' width='24px' />
                    RU
                </button>
                <button onClick={() => handleLanguageClick('en-EN')}>
                    <img src={en} alt='en' width='24px' />
                    EN
                </button>
            </div>
        </div>
    );
};

export default LanguagesPage;
